import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useTable} from 'react-table';
import * as actions from '../../_redux/customersActions';
import * as columnFormatters from '../../../_common/column-formatters';
import {useCustomersUIContext} from '../CustomersUIContext';
import useInfiniteScrollControl
  from '../../../_common/components/_custom-hooks/useInfiniteScrollControl';
import CommonGrid from "../../../_common/components/CommonGrid/CommonGrid";

export function CustomersTable() {
  const {formatMessage} = useIntl();
  const prefix = 'customers-column';
  const [tableRows, setTableRows] = useState([]);
  const columns = useMemo(() => [
    {
      accessor: 'customerID',
      Header: formatMessage({id: `${prefix}-customerID`, defaultMessage: 'CustomerID'})
    },
    {
      accessor: 'fullName',
      Header: formatMessage({id: `${prefix}-fullName`, defaultMessage: 'Full name'})
    },
    {
      accessor: 'idNumber',
      Header: formatMessage({id: `${prefix}-idNumber`, defaultMessage: 'ID number'})
    },
    {
      accessor: 'address',
      Header: formatMessage({id: `${prefix}-address`, defaultMessage: 'Address'})
    },
    {
      accessor: 'phone',
      Header: formatMessage({id: `${prefix}-phone`, defaultMessage: 'Phone number'})
    },
    {
      accessor: 'email',
      Header: formatMessage({id: `${prefix}-email`, defaultMessage: 'Email'})
    },
    {
      accessor: 'totalAmount',
      Header: formatMessage({id: `${prefix}-totalAmount`, defaultMessage: 'Total sum'})
    },
    {
      accessor: 'allowInvoiceDeal',
      Header: formatMessage({id: `${prefix}-allowInvoiceDeal`, defaultMessage: 'Allow invoice deal'})
    },
    {
      accessor: 'addEditCommission',
      Header: formatMessage({id: `${prefix}-addEditCommission`, defaultMessage: 'Add/edit commission'})
    },
    {
      accessor: 'updateCustomerData',
      Header: formatMessage({id: `${prefix}-updateCustomerData`, defaultMessage: 'Update customer data'})
    },
  ], [formatMessage]);
  const data = useMemo(() => [
    ...tableRows.map((item) => {
      return {
        customerID: columnFormatters.BoldColumnFormatter(item.customerID),
        fullName: `${item.firstName} ${item.lastName}` === item.contactName
          ? columnFormatters.LimitContentWidthBoldColumnFormatter(`${item.firstName} ${item.lastName}`)
          : columnFormatters.SeveralItemsColumnFormatter([`${item.firstName} ${item.lastName}`, item.contactName], true),
        idNumber: columnFormatters.BoldColumnFormatter(item.idNumber || ''),
        address: [
          columnFormatters.LimitContentWidthBoldColumnFormatter(item.address?.primary?.city || ''),
          columnFormatters.LimitContentWidthBoldColumnFormatter(item.address?.primary?.street || ''),
         ],
        phone: columnFormatters.PhoneColumnFormatter(item.phoneNumbers || []),
        email: columnFormatters.LimitContentWidthBoldColumnFormatter(item.email),
        totalAmount: columnFormatters.BoldColumnFormatter(Boolean(item.totalAmount)
          ? parseFloat(item.totalAmount).toFixed(2)
          : ''
        ),
        allowInvoiceDeal: columnFormatters.BooleanColumnFormatter(item.allowInvoiceDeal, 'כן לאפשר', 'לא לאפשר'),
        addEditCommission: columnFormatters.AddEditCommissionColumnFormatter(item),
        updateCustomerData: columnFormatters.UpdateCustomerDataColumnFormatter(item),
      };
    })
  ], [tableRows]);

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'customers',
    UIContext: useCustomersUIContext(),
    getNewEntities: actions.getCustomers,
    getNextEntities: actions.getNextCustomers,
    onEntitiesChange: entities => {
      setTableRows(entities);
    },
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (
      <div className={'spinner-container'}>
        <span className={'spinner spinner-md spinner-primary'}/>
      </div>
    ),
    style: {overflow: 'inherit'},
  });

  return (
    <CommonGrid
      infiniteScrollProps={infiniteScrollProps}
      tableProps={useTable({columns, data})}
      customTableStyles={'customers-table'}
    />
  );
}
